'use client';

import { LinkButton as AdsLinkButton, type LinkButtonProps as AdsLinkButtonProps } from '@ads/components-react';

export interface LinkButtonProps extends AdsLinkButtonProps {
  href?: string;
}

export const LinkButton = ({ href, onClick, ...props }: LinkButtonProps) => (
  <AdsLinkButton
    onClick={(e) => {
      if (href) {
        window.location.href = href;
        return;
      }

      onClick?.(e);
    }}
    {...props}
  />
);
